import React, {useState} from 'react';
import {Col, Row, Select} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import TimeSeriesLineChart from '../../../../components/admin/reports/charts/TimeSeriesLineChart';
import {dateFormat, moneyMask} from '../../../../utils/utils';

const GROUP_BY_OPTIONS = [
    {value: 'day', label: 'Dia'},
    {value: 'week', label: 'Semana'},
    {value: 'month', label: 'Mês'},
];
const PERIOD_FORMAT = {day: 'DD/MM', week: 'DD/MM', month: 'MMM/YY'};

// Duas séries com escalas diferentes (receita em R$, pedidos em unidades) —
// small multiples ao invés de eixo duplo. avg_ticket só aparece no tooltip.
export default function RevenueChart({dateFrom, dateTo}) {
    const [groupBy, setGroupBy] = useState('day');
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_REVENUE,
        params: {date_from: dateFrom, date_to: dateTo, group_by: groupBy},
        dataDefault: {},
    });
    const series = data?.series || [];
    const groupBySelect = (
        <Select value={groupBy} onChange={setGroupBy} options={GROUP_BY_OPTIONS} size="small" style={{width: 110}}/>
    );

    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Receita ao Longo do Tempo" loading={isLoading} isEmpty={!series.length} extra={groupBySelect}>
                    <TimeSeriesLineChart
                        data={series}
                        dataKey="revenue"
                        type="area"
                        periodFormatter={(v) => dateFormat(v, PERIOD_FORMAT[groupBy])}
                        valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                        tooltipFields={[
                            {key: 'revenue', label: 'Receita', formatter: (v) => `R$ ${moneyMask(v)}`},
                            {key: 'avg_ticket', label: 'Ticket Médio', formatter: (v) => `R$ ${moneyMask(v)}`},
                        ]}
                    />
                </ReportChartCard>
            </Col>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Pedidos ao Longo do Tempo" loading={isLoading} isEmpty={!series.length}>
                    <TimeSeriesLineChart
                        data={series}
                        dataKey="orders"
                        type="bar"
                        periodFormatter={(v) => dateFormat(v, PERIOD_FORMAT[groupBy])}
                        tooltipFields={[{key: 'orders', label: 'Pedidos'}]}
                    />
                </ReportChartCard>
            </Col>
        </Row>
    );
}
